var _g, _rect, _g2, _rect2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoxBackground = function SvgBoxBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7611_8205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#background-gradient)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    transform: "matrix(1,0,0,1,0,-4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7611_8205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#arc)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7611_8205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682 2.99999C724.244 3.16361 711.568 3.30458 666.795 3.42471C475.998 14.2726 19.0098 229.751 -4.56056 377.299C-4.56215 419.795 -4.80833 434.138 -5.49995 390C-5.56532 385.829 -5.24644 381.593 -4.56056 377.299C-4.5567 273.932 -6 4 -6 4C-6 4 514.96 3.83212 666.795 3.42471C672.072 3.12468 677.145 2.98118 682 2.99999Z",
    fill: "#FAE1ED"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7611_8205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    ienty: 0,
    width: "100%",
    height: "100%"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#bottom-grad-1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7611_8205)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 0,
    y: 230,
    width: "100%",
    height: 415,
    fill: "url(#bottom-gradient-2)",
    fillOpacity: 0.78
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7611_8205",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_7611_8205"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7611_8205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7611_8205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-gradient",
    x1: 307,
    y1: 0,
    x2: 307,
    y2: 349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00529C",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DCC7",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arc",
    x1: 307,
    y1: 0,
    x2: 307,
    y2: 349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00529C",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DCC7",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottom-gradient-1",
    x1: 307,
    y1: 0,
    x2: 307,
    y2: 349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00529C",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37DCC7",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottom-gradient-2",
    x1: 314,
    y1: 334,
    x2: 314,
    y2: 238.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199827,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoxBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "box-background.a06ac3e333107977027fa31f5e05fa86.svg";